/**
 * Precision for drawing and snapping on sketch
 */
export enum Precision {
  whole = 1,
  half = 2,
  decimal = 10,
  inches = 12,
  gridSize = 20,
  lcm = 60,
}
